import { ChangeDetectionStrategy, Component, InputSignal, Signal, computed, inject, input } from '@angular/core';

import { ELinkType, IBlock, buttonOfContent } from '@rt-tools/cms-contract';
import { BlockDirective, ElemDirective } from '@rt-tools/core';
import { RtButtonDirective } from '@rt-tools/ui-kit-v2';

import { BLOG_BLOCK_PAGE, IBlogBlockPage } from '../blog-block-page.tokens';

const BEM_BLOCK: string = 'sc-blog-button-block';

// Внешняя кнопка открывается тем окном и с той пометкой для поиска, что выбрал редактор.
function relOf(button: IBlock.Content.Button): string | null {
    const rel: string[] = [...(button.newTab ? ['noopener'] : []), ...(button.noFollow ? ['nofollow'] : [])];
    return rel.length === 0 ? null : rel.join(' ');
}

@Component({
    selector: 'sc-blog-button-block',
    templateUrl: './blog-button-block.component.html',
    styleUrl: './blog-button-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // rt-tools
        BlockDirective,
        ElemDirective,
        RtButtonDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class BlogButtonBlockComponent {
    readonly #page: Signal<IBlogBlockPage> = inject(BLOG_BLOCK_PAGE);

    protected readonly button: Signal<IBlock.Content.Button> = computed(() => buttonOfContent(this.content(), ''));

    // Кнопка на страницу сайта ведёт по пути опубликованной единицы; неопубликованная — кнопки нет.
    protected readonly href: Signal<string | null> = computed((): string | null => {
        const button: IBlock.Content.Button = this.button();
        if (button.linkType === ELinkType.External) {
            return button.link;
        }
        return this.#page().paths.get(button.contentItemId ?? '') ?? null;
    });
    protected readonly rel: Signal<string | null> = computed(() => relOf(this.button()));

    /** Содержимое блока кнопки. */
    public readonly content: InputSignal<string> = input.required<string>();
}
